//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ServiceObjectMaintenanceNotesTable from './ServiceObjectMaintenanceNotesTable.vue'

export default {
  components: {
    ServiceObjectMaintenanceNotesTable
  },
  props: {
    sourceProps: {
      type: Object,
      default: function () {
        return null
      }
    },
    report: {
      type: Object,
      default: function () {
        return null
      }
    },
    displayLabel: {
      type: Boolean,
      default: false
    },
    useMobileLayout: {
      type: Boolean,
      default: false
    },
    simpleMobile: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClose: function () {
      this.$emit('cancel')
    },
    onSave: function () {
      this.$emit('accept')
    }
  }
}

